export const orderStatuses = [
  'booked',
  'confirmed',
  'journaled',
  'cancelled',
  'pending_for_refund',
  'in_refund',
  'refunded',
];

export const changeOrderStateRgdForCyrillic = (state) => {
  const options = {
    booked: 'Забронирован',
    confirmed: 'Выполнен',
    journaled: 'Выписан',
    cancelled: 'Отменен',
    voided: 'Отменен',
    pending_for_refund: 'В работе (Возврат отправлен)',
    in_refund: 'В работе (Обработка возврата)',
    refunded: 'Возвращен',
  };

  return options[state];
};

export const changeOrderStateForCyrillic = (state) => {
  const options = {
    booked: 'Забронирован',
    confirmed: 'Подтвержден',
    journaled: 'Выписан',
    cancelled: 'Отменен',
    voided: 'Отменен',
    pending_for_refund: 'Возврат отправлен',
    in_refund: 'Обработка возврата',
    refunded: 'Возвращен',
    completed: 'Выполнен',
    pending: 'В работе',
    failed: '',
  };

  return options[state];
};

export const changeOrderItemStateForCyrillic = (state) => {
  const options = {
    booking_success: 'Забронирован',
    booking_cancelled: 'Бронь отменена',
    confirmation_pending: 'Ожидает выписки',
    confirmation_success: 'Выписан',
    confirmation_failed: 'Неуспешная выписка',
    refund_success: 'Возвращен',
    refund_pending: 'Ожидает возврата',
  };

  return options[state];
};

export const changePassportTypeForCyrillic = (state) => {
  const options = {
    RussianPassport: 'Паспорт РФ',
    InternationalPassport: 'Загран. паспорт',
    ForeignPassport: 'Иностранный паспорт',
  };

  return options[state];
};

export const changeOrderStateHotelForCyrillic = (state) => {
  const options = {
    created: 'Создан',
    booked: 'Черновик',
    confirmed: 'Забронирован',
    journaled: 'Ожидает подтверждения',
    cancelled: 'Отменен',
    pending_for_refund: 'Возврат отправлен',
    in_refund: 'Обработка возврата',
    refunded: 'Возвращен',
  };

  return options[state];
};

export const getHotelStatusName = (status) => {
  switch (status) {
    case 'booked':
      return 'Черновик';
    case 'journaled':
      return 'Ожидает подтверждения';
    case 'confirmed':
      return 'Забронирован';
    default:
      return changeOrderStateForCyrillic(status);
  }
};

export const getHotelStatusColor = (status, classes) => {
  switch (status) {
    case 'booked':
    case 'journaled':
      return classes.stateBooked;
    case 'cancelled':
      return classes.stateCancelled;
    default:
      return classes.stateConfirmed;
  }
};
